import { useState } from 'react';
import { initI18nWithoutICU } from '@wix/wix-i18n-config';
import { useTranslationsLoader } from './translations';
export const useInitEssentials = (props) => {
    const { languageCode, experiments } = props ?? {};
    const [i18n] = useState(initI18nWithoutICU({
        locale: languageCode || 'en',
        messages: {},
    }));
    const i18nInstance = props?.i18n || i18n;
    const { t, ready } = useTranslationsLoader(i18nInstance);
    return { essentials: { t, i18n: i18nInstance, experiments }, ready };
};
//# sourceMappingURL=essentials.js.map